import React from 'react';

// DO NOT EDIT - THIS FILE IS GENERATED
/* eslint-disable */

var productCareTumbleDryMediumIcon = /*#__PURE__*/React.createElement("svg", {
  height: "24",
  width: "24",
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, /*#__PURE__*/React.createElement("g", {
  fill: "currentColor",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M11.373 9.422c0 .664-.541 1.21-1.208 1.21a1.213 1.213 0 0 1-1.209-1.21c0-.67.542-1.206 1.209-1.206s1.208.536 1.208 1.206m3.87 0a1.21 1.21 0 0 1-1.201 1.21 1.21 1.21 0 0 1-1.202-1.21 1.201 1.201 0 1 1 2.403 0M20.8 21.425H3.4v-.485c0-.533.432-.965.966-.965h15.468c.533 0 .965.432.965.965v.485Zm0 2.576H3.4v-.485c0-.533.432-.965.966-.965h15.468c.533 0 .965.432.965.965V24Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M20.139 0c.4 0 .725.325.725.725v17.402a.723.723 0 0 1-.722.722H4.06a.722.722 0 0 1-.723-.722V.726c0-.401.325-.726.726-.726h16.076Zm-.725 1.45H4.787v15.949h14.627V1.449Z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M12.1 3.988a5.442 5.442 0 0 1 5.437 5.437A5.442 5.442 0 0 1 12.1 14.86a5.441 5.441 0 0 1-5.437-5.436A5.441 5.441 0 0 1 12.1 3.988Zm0 1.45a3.99 3.99 0 0 0-3.987 3.987A3.99 3.99 0 0 0 12.1 13.41a3.992 3.992 0 0 0 3.987-3.986A3.992 3.992 0 0 0 12.1 5.438Z"
})));

export { productCareTumbleDryMediumIcon as default };
//# sourceMappingURL=productCareTumbleDryMediumIcon.js.map
